import * as React from "react"
import { useSignal } from "@preact/signals-react";
import {Box, Divider, Skeleton, Typography} from "@mui/material"
import {AmchartSeeker, ButtonIconSeeker, ImageSeeker, ModalSeeker, TextFieldSeeker} from "@ui-seeker/core"
import {isEmpty, postSubmit} from "@ui-seeker/utils";
import {useAppToast} from "@ui-seeker/app";

import {ActionButton} from "@components";
import {monitoringResultsRefreshDataModalIsOpen, } from "./@signals";
import {useMonitoringResulRefreshDataModal} from "./@hooks";



export default function MonitoringResultsRefreshDataModal() {
    const { showToast } = useAppToast()
    const { scopeData, isLoading, handleRefreshDataTest, refreshData, handleResetSignals, refreshDataError } = useMonitoringResulRefreshDataModal()

    if (!monitoringResultsRefreshDataModalIsOpen.value)
        return <></>

    return <ModalSeeker
        hideActions
        id="evolution-details-chart1"
        isOpen={monitoringResultsRefreshDataModalIsOpen.value}
        title={'Refresh Data'}
        controller={() => {
            handleResetSignals()
            monitoringResultsRefreshDataModalIsOpen.value = false
        }}
        sx={{ width: 80}}
    >
        {isLoading && <Skeleton variant="rectangular" height={300} />}

        {!!refreshDataError && <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Typography>{refreshDataError}</Typography>
        </Box>}

        {refreshData && <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Typography>The data extraction has been launched</Typography>
            <Typography>In a few minutes, you’ll be able to see the results in this same window.</Typography>
            <Typography>The new data will appear under the current hour timestamp. </Typography>
        </Box>}

        {!isLoading && !refreshData && ! refreshDataError && <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
            <Typography sx={{ mb: 2 }}>
                You’re about to update the prices of <strong>{scopeData.skus} SKUs </strong> across <strong>{scopeData.sites} websites. </strong> This action may trigger
                up to <strong>{scopeData.searches} searches </strong>, which could impact your monthly billing. Do you want to proceed?
            </Typography>
            <ActionButton
                label="Refresh Data"
                icon="arrows-rotate"
                onClick={handleRefreshDataTest}
            />
        </Box>}
    </ModalSeeker>
}